import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'
import type { QuickRepliesMessageFeedback } from '../types/messageTypes'

interface SendFeedbackChatbotEventProps {
	id: number
	label: QuickRepliesMessageFeedback
}
export const sendFeedbackChatbotEvent = ({
	id,
	label,
}: SendFeedbackChatbotEventProps): void => {
	sendGenericEvent('feedback_chatbot', {
		id,
		label_1: label,
	})
}
